/**
 * The welcome runs once per account, per browser. It is a moment, not a page
 * anyone navigates back to — so it is remembered locally rather than stored on
 * the profile, and a blocked or cleared storage just means seeing it again.
 */

const KEY = 'ba.welcome.seen.';

export function welcomeSeen(userId: string): boolean {
  try {
    return window.localStorage.getItem(KEY + userId) === '1';
  } catch {
    return false;
  }
}

export function markWelcomeSeen(userId: string): void {
  try {
    window.localStorage.setItem(KEY + userId, '1');
  } catch {
    // Private mode or blocked storage: the page may show once more. Harmless.
  }
}

export const INSTAGRAM_URL = import.meta.env.VITE_INSTAGRAM_URL || 'https://www.instagram.com/brahmastra.studio';
export const YOUTUBE_URL = import.meta.env.VITE_YOUTUBE_URL || 'https://www.youtube.com/@brahmastrastudio';

/** Who is in the pool — cycled through on the page, in this order. */
export const CREATOR_KINDS = [
  'Filmmakers',
  'Directors',
  'AI artists',
  'Editors',
  'VFX artists',
  'Advertising creators',
  'Storytellers'
];
